<template>
  <div>
    <h2 class="ViewHeading" v-if="UserProfile == 'SUP'">Hardware Admin</h2>
    <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab>
          <template #title> C-1 Devices</template>
          <b-card>
            <b-tabs>
              <b-tab>
                <template #title> Device List</template>
                <b-table :items = "C1Array" :fields="C1Fields">
                  <template v-slot:cell(ID)="{ item }">
                  {{ getNewName(item.ID, "C1") }}
                  </template>
                </b-table>
              </b-tab>
              <b-tab>
                <template #title> Device Actions</template>
                <C1Actions/>
              </b-tab>
              <b-tab>
                <template #title> Device Calibrations</template>
                <C1Calib/>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-tab>
        <b-tab>
          <template #title> O-1 Devices</template>
          <b-card>
            <b-tabs>
              <b-tab>
                <template #title> Device List</template>
                <b-table :items = "O1Array" :fields="O1Fields">
                  <template v-slot:cell(ID)="{ item }">
                  {{ getNewName(item.ID, "O1") }}
                  </template>
                </b-table>
              </b-tab>
              <b-tab>
                <template #title> Device Actions</template>
                <O1Actions/>
              </b-tab>
              <b-tab>
                <template #title> Device Calibrations</template>
                <O1Calib/>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-tab>
        <b-tab>
        <template #title>Routers</template>
        <Routers/>

        </b-tab>
      </b-tabs>
    </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import {} from "bootstrap-vue";
import C1Actions from "../components/ActionComponents/ActionsC1.vue";
import O1Actions from "../components/ActionComponents/ActionsO1.vue";
import C1Calib from "../components/CalibrationComponents/CalibrationC1.vue";
import O1Calib from "../components/CalibrationComponents/CalibrationO1.vue";
import { IDToHuman } from "../CustomFunctions/HumanName.js";
import Routers from "../components/Routers.vue"

export default {
  computed: {},
  components: {
    C1Actions,
    O1Actions,
    C1Calib,
    O1Calib,
    Routers
  },

  data() {
    return {
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserProfile: localStorage.getItem("profileportal"),
      UserAccess: localStorage.getItem("accessGroup"),
      raisedFromText: "",
      C1Array: [],
      O1Array: [],
      deviceForAction: "",
      typeForAction: "",
      O1Fields:[
        "ID",
        "Type",
        "DeptFloor",
        "PositionNote",
        "LocationGroups",
        "Status"
      ],
      C1Fields:[
        "ID",
        "Type",
        "DeptFloor",
        "PositionNote",
        "LocationGroups",
        "Status"
      ],
      DeviceIDToChange: { C1: [], O1: [] },
      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
    };
  },

  beforeMount() {},

  mounted() {
    this.raisedFromText = "Super User Admin";
    let RaiseID = "N/A";
    Vue.prototype.$RaisedFromID = RaiseID;
    Vue.prototype.$RaisedFrom = this.raisedFromText;

    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ClarenceDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          Feed: "",
          State: "",
        },
      ],
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {

        let fulldataarray = response.data.Values

        for (let x=0;x<fulldataarray.length;x++){
          if(fulldataarray[x][6] == 'C-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.C1Array.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          } 
          if(fulldataarray[x][6] == 'O-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.O1Array.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          }
        }

        this.SwitchToHuman("C1");
        this.SwitchToHuman("O1");

      });


  },
  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      let ClarenceType = Type;

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      Type = Type.replace("-", "");
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    }

  },
};
</script>

<style>
.cardtitle {
  color: gray;
  font-size: medium;
  font-weight: bold;
}
.groupname {
  color: gray;
  font-size: small;
  margin: 0;
}
.grouptitle {
  color: black;
  padding: 0;
  margin: 0;
}
.O1ID {
  font-size: small;
}

.modal {
  text-align: center;
}
</style>
